// extracted by mini-css-extract-plugin
module.exports = {"root":"IndentedContainer_root_ohOdw","main":"IndentedContainer_main_3o_pH","gallery-list":"IndentedContainer_gallery-list_1TnC1"};